import { useSelector } from 'react-redux'
import { educationClient } from '../selectors'

export default function useEducationClient() {
  return useSelector(educationClient)
}
